export namespace GeofenceConstants {
  export const GEOFENCE_CONDITION_ALLOWED_CODE: string = 'ALWD';
  export const GEOFENCE_CONDITION_DISALLOWED_CODE: string = 'DALWD';

  export const GEOFENCE_TYPE_RESTRICTED_PICK_UP_CODE: string = 'RPU';
  export const GEOFENCE_TYPE_RESTRICTED_DROP_OFF_CODE: string = 'RDO';
  export const GEOFENCE_TYPE_RESTRICTED_PICK_UP_AND_DROP_OFF_CODE: string = 'RPUDO';
  export const GEOFENCE_TYPE_REGIONAL_TRACKING_ZONE_CODE: string = 'RTZ';
}
